import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCreateDraftError, getIsCreatingDraft } from '../selectors';
import { createDraftPpsi as createDraftPpsiAction } from '../actions';

const useCreateDraftPpsi = () => {
  const [isStarted, setIsStarted] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const dispatch = useDispatch();
  const isCreatingDraft = useSelector(getIsCreatingDraft);
  const error = useSelector(getCreateDraftError);
  const isCreatedWithoutError = !isCreatingDraft && !error;

  if (isStarted && isCreatedWithoutError) {
    if (!isCreated) {
      setIsCreated(true);
    }
  }

  const createDraftPpsi = (id, status) => {
    dispatch(createDraftPpsiAction(id, status));
    setIsStarted(true);
  };

  return [createDraftPpsi, isCreatingDraft, isCreated];
};

export default useCreateDraftPpsi;
